import React from "react";
import { useParams } from "react-router-dom";
import Form from "../components/EditBook/Form";
import { useGetBookQuery } from "../features/api/apiSlice";

const EditBook = () => {
  const { bookId } = useParams();


  const { isError, isLoading, isSuccess, data: book } = useGetBookQuery(bookId);

  let content = null
  if(isSuccess) content = <Form book={book} />
  return (
    <main className="py-6 2xl:px-6">
      <div className="container">
        <div className="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
          <h4 className="mb-8 text-xl font-bold text-center">Edit Book</h4>
          {content}
        </div>
      </div>
    </main>
  );
};

export default EditBook;
